import { i18nDateToString, stringToDate } from 'modules/core/lib/dates'

import { usePrivateIntegrationsSyncContext } from 'modules/integrations/hooks/SyncContext'
import { useLastSyncRunLabels } from 'modules/integrations/hooks/useLastSyncRunLabels'

export type SyncMetadataItem = {
  label: string
  value: {
    type: 'text'
    content: string
  }
}

const formatDate = (date: string): string => {
  return i18nDateToString(stringToDate(date, 'backend_datetime'), 'ui_month_day_time')
}

const metadataBuilder = (title: string, value: string): SyncMetadataItem => {
  return {
    label: title,
    value: {
      type: 'text',
      content: value,
    },
  }
}

export const useSyncMetadata = (): SyncMetadataItem | null => {
  const { isSyncing, lastSyncRun, syncEnabled } = usePrivateIntegrationsSyncContext()
  const { syncingLabel, lastSyncLabel, noLastSyncLabel } = useLastSyncRunLabels()

  if (!syncEnabled) return null
  if (isSyncing) return metadataBuilder('', syncingLabel())
  else if (lastSyncRun?.finishedAt)
    return metadataBuilder(lastSyncLabel(), formatDate(lastSyncRun.finishedAt))
  return metadataBuilder('', noLastSyncLabel())
}
